import type { FaireProductEntity } from "../../entity_types/product";

export const p_47aj5q5rp5: FaireProductEntity = {
  token: "p_47aj5q5rp5",
  type: "product",
  name: "Kayla Cross Necklace",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/f093fd4caf1168daa811dab58604c3657ae43d2517c409f5eebe873f8bebd3f2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55bfbd3316a0787cd8a3400617ba481ded9a5bf649d85989abaeae067cd7c331.jpeg",
    "https://cdn.faire.com/fastly/249f8068be6bfa00b07dc128ad11751981273b932d8f2f8bb8db5b595c096e4a.jpeg",
    "https://cdn.faire.com/fastly/1e7bea8aa34140b717853217e344b162365782a60e6b649ecb1ab2b79ad71cd1.jpeg",
    "https://cdn.faire.com/fastly/77a0ec55470ca5e5b0679adadc1f47f81e816dd734a5cdf0007f7511f39bdc40.jpeg",
    "https://cdn.faire.com/fastly/3b57c04d17e7827e2504d886743dc2845c5bc3cd04ac22577036e1a42989e59b.jpeg",
  ],
  priceDollars: 7.94,
  description:
    "Side hanging cross necklace. The beauty of this necklace is the simplicity. Clean and simple design of side hanging cross looks so understated and edgy! Great to make layers with different necklaces you already own! \n\n16 inch chain with 2 inch extender. \n\nStainless steel, 18 K gold plated. Great quality that will last a long with no tarnishing.\n\nLead and Nickel Free \n\nMade in China",
  tags: [],
  msrpDollars: 22.85,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:45.333Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
